import { List, Map } from "immutable";

import actionTypes from "../../../action-types";
import Content from "../../../models/state/contents/content/Content";
import ContentOptions from "../../../models/state/contents/content/options/ContentOptions";
import { Contents } from "../../../models/state/contents/Contents";

export default function contentsReducer(
  contents: Contents = Map<string, Content>(),
  action: Record<string, any>
) {
  switch (action.type) {
    case actionTypes.ADD_COURSE: {
      const course = action.payload.course;
      return contents.merge(flattenContents(course));
    }

    case actionTypes.ADD_COURSE_SKELETON: {
      return contents.mergeDeep(
        flattenMissingSectionsContents(contents, action.payload.sections)
      );
    }

    case actionTypes.ADD_SECTION: {
      return contents.merge(flattenContents(action.payload.section));
    }

    default:
      return contents;
  }
}

export function flattenContents(course: Record<string, any>) {
  return flattenSectionContents(Map<string, Content>(), course);
}

export function flattenMissingSectionsContents(
  contents: Map<string, Content>,
  sections: Record<string, any>
) {
  return sections.reduce(
    (contents: Map<string, Content>, section: Record<string, any>) =>
      flattenSectionContents(contents, section).merge(contents),
    contents
  );
}

export function flattenSectionsContents(sections: Record<string, any>) {
  let contents = Map<string, Content>();

  if (sections) {
    sections.forEach((section: any) => {
      contents = contents.merge(flattenSectionContents(contents, section));
    });
  }

  return contents;
}

function flattenSectionContents(
  contents: Contents,
  section: Record<string, any>
) {
  if (section.contents) {
    section.contents.forEach((content: any) => {
      const { id, contentModules, options, ...rest } = content;
      contents = contents.set(
        id,
        new Content({
          id,
          ...rest,
          parentId: rest.parentId ?? section.id,
          options: new ContentOptions(options),
          contentModuleIds: List(
            contentModules?.map((contentModule: any) => contentModule.id)
          )
        })
      );
    });
  }

  if (section.sections) {
    section.sections.forEach(
      (section: any) =>
        (contents = contents.merge(flattenSectionContents(contents, section)))
    );
  }

  return contents;
}
